import { AlertCircle, Calendar } from "lucide-react";

/**
 * Right rail of the dashboard — overdue + next 14 days follow-ups, fed by
 * /api/dashboard/stats (`overdue_followups`, `upcoming_followups`).
 */
export default function FollowUpsPanel({ stats }) {
  if (!stats) return null;
  const overdue = stats.overdue_followups || [];
  const upcoming = stats.upcoming_followups || [];
  const empty = overdue.length === 0 && upcoming.length === 0;

  return (
    <div className="surface p-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <div className="label-eyebrow">Upcoming</div>
          <h2 className="font-heading text-xl uppercase mt-1">Follow-ups</h2>
        </div>
        <Calendar className="w-4 h-4 text-ink-muted" />
      </div>

      {overdue.length > 0 && (
        <div className="mb-5 pb-5 border-b border-[#FF3B30]/30" data-testid="overdue-followups">
          <div className="label-eyebrow text-[#FF3B30] mb-3 flex items-center gap-1.5">
            <AlertCircle className="w-3.5 h-3.5" /> Overdue · {overdue.length}
          </div>
          <ul className="space-y-2.5">
            {overdue.map(f => (
              <li key={f.deal_id} className="flex justify-between items-center gap-2"
                  data-testid={`overdue-${f.deal_id}`}>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold truncate">{f.brand_name}</div>
                  <div className="text-[10px] text-ink-muted uppercase tracking-widest">{f.status}</div>
                </div>
                <div className="text-[10px] text-[#FF3B30] font-mono whitespace-nowrap">
                  {f.days_overdue === 1 ? "1 day late" : `${f.days_overdue} days late`}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {empty ? (
        <div className="text-sm text-ink-muted">No follow-ups in the next 14 days.</div>
      ) : upcoming.length === 0 ? (
        <div className="text-xs text-ink-muted">No upcoming follow-ups in the next 14 days.</div>
      ) : (
        <>
          {overdue.length > 0 && <div className="label-eyebrow mb-3">Next 14 days</div>}
          <ul className="space-y-3">
            {upcoming.map(f => (
              <li key={f.deal_id || f.brand_id}
                  className="flex justify-between items-center border-b border-line pb-2 last:border-0">
                <div>
                  <div className="text-sm font-semibold">{f.brand_name}</div>
                  <div className="text-xs text-ink-muted uppercase tracking-widest">{f.status}</div>
                </div>
                <div className="text-xs text-volt font-mono">{f.date.slice(0, 10)}</div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
